module.exports = __webpack_public_path__ + "static/media/explore-more-icon-2.c77f1f2a.svg";